import { getWeather } from '@/api/overview';
// import { setToken, getToken } from '@/libs/util'

export default {
  state: {
    weatherData: {
      realtime: {},
      future: [{ temperature: 0 }],
    },
    // statTotal: {},
  },
  mutations: {
    updateWeather(state, val) {
      state.weatherData = val;
    },
    // getStatTotal(state, { data }) {
    //   state.siteStatTotal = data['site_stat']['total'];
    // },
  },
  actions: {
    handleWeatherInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getWeather(params)
          .then((res) => {
            // console.log('store--weather--res-----', res);
            commit('updateWeather', res);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // dimensionality({ commit }, params) {
    //   return new Promise((resolve, reject) => {
    //     dimensionality(params)
    //       .then((data) => {
    //         console.log('store-------data----', data);
    //         commit('getStatTotal', { data });
    //         resolve(data);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
  },
};
